import {
    initFavorite,
    initToggle
} from '@/common/scripts/common';
import {DESKTOP_BREAKPOINT} from '@/common/scripts/constants';
import emptyResultTemplate from './template/error.twig';
import Observer from '@/common/scripts/observer';
import {PopupFacade} from '../popup/popupFacade';

import resultTemplate from './template/result.twig';
import {Utils} from '@/common/scripts/utils.js';

const observer = new Observer();

class FlatConstructor {
    constructor(options) {
        // Активный шаг
        this.step = null;
        // Идентификатор последнего шага
        this.lastStep = null;
        // Тип планировки
        this.planType = [];
        // Клиентское название типа планировки
        this.planTypeName = null;
        // Активный класс
        this.activeClass = 'is-active';
        // Неактивный класс
        this.disableClass = 'is-disable';
        // Класс обертки элемента
        this.wrapperClass = '.j-constructor__element-wrapper';
        // Родительский класс элемента
        this.elementParentClass = '.j-constructor__element-parent';
        // Класс элемента инпута
        this.elementClass = '.j-constructor__element';
        // Шаблон с результатом
        this.template = null;
        // Объект выбранного элемента
        this.selectedElement = null;
        // Виджет планоплана
        this.planoplanWidget = document.querySelector('.j-flat__planoplan-widget');

        this._init(options);
    }

    /* eslint-disable max-statements */
    _init(options) {
        this.popup = options.element;
        this.element = options.element.popup;
        // Содержимое результата ответа бека
        this.data = options.element.data.content;
        // Элемент данных со значениями всех комбинаций планировок
        this.dataPlansType = this.data.plansType;
        // Контентное поле
        this.content = this.element.querySelector('.j-popup__content');
        // Элемент с планом планировок
        this.plan = this.element.querySelector('.j-constructor__plan');
        // Кнопка очистки выбора
        this.clear = this.plan.querySelector('.j-constructor__plan-clear');
        // Массив масок на плане
        this.masks = Array.from(this.plan.querySelectorAll('.j-constructor__mask'));
        // Массив всех элементов на плане
        this.planIMG = Array.from(this.plan.querySelectorAll('.j-constructor__plan-img'));
        // Элемент с текстом выбора шага
        this.stepText = this.plan.querySelector('.j-constructor__plan-text');
        // Элемент для вывода результата конструктора
        this.result = this.element.querySelector('.j-constructor__result-text');
        // Массив всех групп шагов
        this.groups = Array.from(this.element.querySelectorAll(this.wrapperClass));
        // Массив всех элементов в выборщике элементов планировок
        this.elements = Array.from(this.element.querySelectorAll(this.elementClass));
        // Массив родительских "оберток" у элементов в выборщике элементов
        this.elementsParent = Array.from(this.element.querySelectorAll(this.elementParentClass));
        // Идентификатор последнего шага
        this.lastStep = null;
        this.tooltipWrapper = this.element.querySelector('.j-toggle-wrapper');
        this.isMobile = Utils.getWindowWidth() < DESKTOP_BREAKPOINT;

        this.elementsWrapper = this.element.querySelector('.j-constructor-elements');

        this._initLastStep();
        this._initFlatElements();
        this._bindEvents();

        initToggle(this.tooltipWrapper);
    }
    /* eslint-enable max-statements */

    _initLastStep() {
        if (!this.elements?.length) {
            return;
        }

        this.lastStep = this.elements[this.elements.length - 1].dataset.step;
    }

    _initFlatElements() {
        // Элемент в шапке попапа с номером планировки
        this.planHead = document.querySelector('.j-popup-head-plan');
        // Элемент на странице квартиры с указанием планировки
        this.pagePlan = Array.from(document.querySelectorAll('.j-constructor-action__id'));
        this.mainPrice = document.querySelector('.j-flat-main-price');
        this.oldPrice = document.querySelector('.j-flat-old-price');
        this.areaPrice = document.querySelector('.j-flat-area-price');
        this.mortgagePrice = document.querySelector('.j-mortgage-price');
        this.area = Array.from(document.querySelectorAll('.j-flat-area'));
        this.mortgagePayment = document.querySelector('.j-range-slider__input[name="first-pay[min]"]');
        this.imagePopup = document.querySelector('.j-flat__popup-image');
        this.imageElement = document.querySelector('.j-flat__image');
        this.favorite = document.querySelector('.j-favorite');
        this.flatTitle = document.querySelector('.j-flat-title')?.innerText || null;
        // Картинка с параллакс-эффектом
        this.parallax = this.element.querySelector('.j-parallax-flat');
        this.parallaxWrapper = this.element.querySelector('.j-parallax-wrapper');
        this.parallaxBg = this.element.querySelector('.j-parallax-bg');
        // Картинка с зумом
        this.zoomPicture = this.element.querySelector('.j-plan-zoom-picture');
        this.zoomButton = this.element.querySelector('.j-plan-zoom-btn');
    }

    _bindEvents() {
        this._setFirstStep();
        this._setStartPlan();
        this._bindClear();
        this._bindRadio();
        this._bindHover();
        this._bindZoom();
        this._bindParallax();

        const pagePlanHead = document.querySelector('.j-constructor-action');

        if (pagePlanHead) {
            pagePlanHead.classList.remove('is-active');
        }

        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, () => {
                this.isMobile = Utils.getWindowWidth() < DESKTOP_BREAKPOINT;
            });
        });
    }

    _setFirstStep() {
        const firstElement = this.elements[0];

        this.step = firstElement.dataset.stepId;

        // Отключаем все элементы, кроме первого шага
        this.elements.forEach((element) => {
            element.checked = false;

            if (element.dataset.step !== firstElement.dataset.step) {
                this._setElementState(false, element);
                this._setParentElementState(false, element);
            }
        });
    }

    // Копируем тип изначальной планировки из карточки квартиры в конструктор
    _setStartPlan() {
        this.planHead.innerText = this.pagePlan.length ? this.pagePlan[0].innerText : '';
    }

    /**
     * Навешивает параллакс-эффект на картинку
     */
    _bindParallax() {
        if (!this.parallax) {
            return;
        }

        if (!this.isMobile) {
            this.parallaxWrapper.addEventListener('mousemove', (event) => {
                const x = event.clientX / window.innerWidth;
                const y = event.clientY / window.innerHeight;

                this.parallaxBg.style.paddingTop = '80px';
                this.parallaxBg.style.transform = `scale(1.5) translate(-${x * 100}px, -${y * 100}px)`;
            });

            this.parallaxWrapper.addEventListener('mouseout', () => {
                this.parallaxBg.style.transform = 'none';
                this.parallaxBg.style.paddingTop = '0';
            });
        } else if (this.isMobile) {
            let event = null;

            this.parallaxWrapper.addEventListener('touchstart', (ev) => {
                event = ev;
            });

            this.parallaxWrapper.addEventListener('touchmove', (ev) => {
                if (event) {
                    if (this.parallaxBg.classList.contains('is-fullsize')) {
                        const deltaX = ev.touches[0].pageX - event.touches[0].pageX;
                        const deltaY = ev.touches[0].pageY - event.touches[0].pageY;

                        this.parallaxBg.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(2)`;
                    }
                }
            });

            this.parallaxWrapper.addEventListener('touched', () => {
                event = null;
            });
        }
    }

    _bindZoom() {
        if (!this.zoomPicture || !this.zoomButton) {
            return;
        }

        this.zoomButton.addEventListener('click', () => {
            this.zoomButton.classList.toggle('is-shown');
            this.zoomPicture.classList.toggle('is-fullsize');

            if (this.zoomPicture.classList.contains('is-fullsize')) {
                this.zoomPicture.style.transform = 'scale(2)';
            } else {
                this.zoomPicture.style.transform = 'none';
            }
        });
    }

    /**
     * Очищает выбранные элементы планировки
     */
    _bindClear() {
        if (!this.clear) {
            return;
        }

        this.clear.addEventListener('click', () => {
            this._setFirstStep();

            // Чистим все планировки
            this.planIMG.forEach((plan) => {
                plan.classList.remove(this.activeClass);
            });

            this._setStepText(this.stepText.dataset.default);

            this.stepText.classList.remove(this.disableClass);

            Utils.clearHtml(this.result);

            this.planType = [];

            this._enableAllMask();
            // Возвращаемся наверх - к первой группе
            if (Utils.isMobile()) {
                this.elementsWrapper.scrollTo({
                    top     : 0,
                    behavior: 'smooth'
                });
            } else {
                this.groups[0].scrollIntoView({behavior: 'smooth'});
            }

            if (window.gtag) {
                // eslint-disable-next-line
                window.gtag('event', 'reset_constructor', {send_to: 'G-LLQN03TWXX',});
            }
        });
    }

    /**
     * Вешаем листнер на выбор планировки
     */
    _bindRadio() {
        this.elements.forEach((element) => {
            // eslint-disable-next-line max-statements
            element.addEventListener('change', () => {
                this.tooltipWrapper.classList.remove(this.activeClass);
                this.selectedElement = {
                    id    : element.dataset.id,
                    step  : element.dataset.step,
                    stepId: element.dataset.stepId,
                    layout: element.dataset.layout,
                    link  : `${element.dataset.step}_${element.dataset.id}`
                };

                if (window.gtag) {
                    try {
                        window.gtag('event', 'constructor_step', {
                            // eslint-disable-next-line
                            send_to: 'G-LLQN03TWXX',
                            step   : this.selectedElement.layout,
                            rooms  : this.flatTitle.replace(/\D/g, '')
                        });
                    } catch (error) {
                        console.error(error);
                    }
                }

                if (window.ym) {
                    window.ym(91302277, 'reachGoal', 'build_an_apartment');
                }

                this._setActivePlan();

                if (this.step <= this.selectedElement.stepId) {
                    // Проверяем есть ли уже этот шаг или нет
                    this._checkStep();
                    this._addToPlanType();
                    this._toggleEnableMask(this.selectedElement.step, false);

                    if (this._checkFinish()) {
                        this._calcFinishData();
                    }
                } else {
                    // Деактивируем шаги
                    this._deactivateStep();

                    // Удаляем элементы из массива будущего типа планировки выбранных пунктов планировки
                    const index = this.planType.findIndex((item) => {
                        return item.id === this.selectedElement.step;
                    });

                    this.planType = this.planType.slice(0, Number(index));

                    this._addToPlanType();
                }

                this.step = this.selectedElement.stepId;

                this._activateNextStep();
            });
        });
    }

    _bindHover() {
        this.elementsParent.forEach((element) => {
            const step = element.dataset.step;
            const maskType = element.dataset.mask;

            const mask = this.masks.find((item) => {
                return item.dataset.step === step && Number(item.dataset.type) === Number(maskType);
            });

            element.addEventListener('mouseover', () => {
                this._toggleShowMask(mask, true);
            });

            element.addEventListener('mouseout', () => {
                this._toggleShowMask(mask, false);
            });
        });
    }

    // Работа с масками
    /**
     * Переключает состояние маски - или подсвечиваем или скрываем
     * @param {string} mask - имя маски для показа
     * @param {boolean} state - подсвечиваем (true) / скрываем (false)
     */
    _toggleShowMask(mask, state) {
        state ? mask?.classList.add(this.activeClass) : mask?.classList.remove(this.activeClass);
    }

    /**
     * Делаем маски доступнями для подсветки
     * @param {string} step - состояние какой маски меняем
     * @param {boolean} state - даем возможность подсветить (true) / запрещаем (false)
     */
    _toggleEnableMask(step, state) {
        this.masks.forEach((mask) => {
            if (mask.dataset.step === step) {
                state ? mask.classList.remove(this.disableClass) : mask.classList.add(this.disableClass);
            }
        });
    }

    // Делает все маски активными
    _enableAllMask() {
        const stepNameArray = [];

        this.elements.forEach((item) => {
            stepNameArray.push(item.dataset.step);
        });

        const stepNameUnique = new Set(stepNameArray);

        stepNameUnique.forEach((step) => {
            this._toggleEnableMask(step, true);
        });
    }

    // Добавляем ид выбранного компонента планировки
    _addToPlanType() {
        this.planType.push({
            id   : this.selectedElement.step,
            value: this.selectedElement.layout
        });
    }

    // Проверяем не является ли выбранный шаг уже текущим, если так и есть , то удаляем выбранный ранее элемент
    _checkStep() {
        if (this.planType.length) {
            const findedPlan = this.planType.find((item) => {
                return item.id === this.selectedElement.step;
            });

            if (findedPlan) {
                this.planType.pop();
            }
        }
    }

    /**
     * Отображаем выбранную планировку на миниплане
     */
    _setActivePlan() {
        const activePlanIMG = this.planIMG.find((item) => {
            return item.dataset.plan === this.selectedElement.link;
        });

        // Если такая планировка нашлась на плане и у нее нет активного класса - ищем есть ли активные планировки текущего уровня, прячем их, а выбранной ставим активный класс
        if (!activePlanIMG?.classList.contains(this.activeClass)) {
            const plansOnStep = this.planIMG.find((item) => {
                return item.dataset.step === this.selectedElement.step && item.classList.contains(this.activeClass);
            });

            if (plansOnStep) {
                plansOnStep.classList.remove(this.activeClass);
            }

            activePlanIMG.classList.add(this.activeClass);
        }
    }

    /**
     * Удаляет элемент с плана планировки соответствующий переданному шагу
     * @param {string} step - переданный шаг
     */
    _removeActivePlan(step) {
        this.planIMG.forEach((element) => {
            if (element.dataset.step === step) {
                element.classList.remove(this.activeClass);
            }
        });
    }

    /**
     * Активируем возможность выбора на следующем шаге
     */
    _activateNextStep() {
        // Ищем все типы планировок у кого имеются набранные типы
        const filteredPlansType = [];

        this.dataPlansType.forEach((item) => {
            const slicedPlane = item['code_array'].slice(0, this.planType.length);
            const planTypeArray = [];

            this.planType.forEach((plan) => {
                planTypeArray.push(plan.value);
            });

            if (this._compareArray(slicedPlane, planTypeArray) && this._compareArray(planTypeArray, slicedPlane)) {
                filteredPlansType.push(item);
            }
        });

        // Получаем все подходящие типы элементов следующего шага
        const nextPlans = [];

        filteredPlansType.forEach((item) => {
            nextPlans.push(item['code_array'][this.selectedElement.stepId]);
        });

        // Уникализируем массив
        const uniquePlans = new Set(nextPlans);
        // Получаем список элементов следующего шага
        const filteredElements = this.elements.filter((element) => {
            if (Number(element.dataset.stepId) === Number(this.selectedElement.stepId) + 1) {
                this._setElementState(false, element);
                this._setParentElementState(false, element);
            }

            return Number(element.dataset.stepId) === Number(this.selectedElement.stepId) + 1;
        });

        // Находим все элементы следующего шага, который содержат планировки из массива uniquePlans
        uniquePlans.forEach((plan) => {
            const acceptPlans = filteredElements.filter((element) => {
                return element.dataset.layout === plan;
            });

            acceptPlans.forEach((element) => {
                this._setElementState(true, element);
                this._setParentElementState(true, element);
            });
        });

        this._scrollToNext();

        if (filteredElements.length) {
            this._setStepText(filteredElements[0].dataset.text);
        }
    }

    /**
     * Деактивируем шаги ниже активного
     */
    _deactivateStep() {
        // Если был финальный шаг и был показан результат планировки - прячем его и показываем подсказку с текущим выбором элемента
        if (this.stepText.classList.contains(this.disableClass)) {
            this.stepText.classList.remove(this.disableClass);

            Utils.clearHtml(this.result);
        }

        const filteredElements = this.elements.filter((element) => {
            return Number(element.dataset.stepId) > Number(this.selectedElement.stepId);
        });


        const filteredStepName = [];

        filteredElements.forEach((element) => {
            element.checked = false;

            this._removeActivePlan(element.dataset.step);

            this._setElementState(false, element);
            this._setParentElementState(false, element);

            filteredStepName.push(element.dataset.step);
        });

        const uniqueStepName = new Set(filteredStepName);

        uniqueStepName.forEach((step) => {
            this._toggleEnableMask(step, true);
        });
    }

    _scrollToNext() {
        const group = this.groups.find((item) => {
            return Number(item.dataset.id) === Number(this.step) + 1;
        });

        if (group) {
            const scrollTop = this.elementsWrapper.scrollTop;
            // Отступ размера заголовка + паддинг
            const offset = 50;
            // Рассчет положения для прокрутки (вносим корректировку на высоту блок с планом)
            const finalOffset = group.getBoundingClientRect().top + scrollTop - this.plan.clientHeight - offset;

            // На мобильных включаем фикс, т.к. iOS не поддерживает scrollIntoView
            setTimeout(() => {
                if (Utils.isMobile()) {
                    this.elementsWrapper.scrollTo({
                        top     : finalOffset,
                        behavior: 'smooth'
                    });
                } else {
                    group.scrollIntoView({
                        behavior: 'smooth',
                        block   : 'start',
                        inline  : 'start'
                    });
                }
            }, 250);
        }
    }

    /**
     * Переключает состояние элемента
     * @param {boolean} state - состояние элемента (доступен для выбора или нет)
     * @param {object} element - элемент
     */
    _setElementState(state, element) {
        state ?
            element.removeAttribute('disabled') :
            element.disabled = true;
    }

    _setParentElementState(state, element) {
        const parent = element.closest(this.elementParentClass);

        state ?
            parent.classList.remove(this.disableClass) :
            parent.classList.add(this.disableClass);
    }

    /**
     * Проверяет является ли выбранный шаг последним или нет
     * @returns {boolean} - булевый результат вычисления последнего шага
     */
    _checkFinish() {
        return this.selectedElement.step === this.lastStep;
    }

    /**
     * Извлекает данные для расчета и вывода данных о стоимости выбранной планировки
     */
    _calcFinishData() {
        const title = this.flatTitle;
        const selectedType = this.planType.reduce((acc, item) => {
            return acc + item.value;
        }, '');
        const typeData = this.dataPlansType.find((item) => {
            return item.code_id === selectedType;
        });

        typeData ?
            this._showFinishData({
                error     : false,
                basicTitle: this.data.external_origin_id,
                flatID    : this.data.id,
                price     : this.data.priceMeterBasic || null,
                salePrice : this.data.priceMeter || null,
                finalImg  : typeData.image || null,
                title,
                typeData}) :
            this._showFinishData({error: true});
    }

    /**
     * Рассчитывает и отображает данные по выбранной планировке
     * @param {object} data - данные для построения сообщения о выбранной планировки
     */
    _showFinishData(data) {
        Utils.clearHtml(this.result);

        this.stepText.classList.add(this.disableClass);
        this.result.classList.add(this.activeClass);
        this.template = data.error ? emptyResultTemplate : resultTemplate;

        if (data.error) {
            this.result.insertAdjacentHTML('afterbegin', this.template());

            return;
        }

        const area = data.typeData.area;
        const priceBasic = data.price ? Utils.convertToDigit(Number(data.price) * Number(area)) : null;
        const priceSale = data.salePrice ? Utils.convertToDigit(Number(data.salePrice) * Number(area)) : null;
        const planTypeID = data.typeData.layoutMainId;
        const planBasicTypeName = data.basicTitle;

        // Ищем названия планировок - исходной и итоговой - в массиве планов
        // this.dataPlansType.forEach((item) => {
        //     // basic
        //     if (item.id === data.typeData.id) {
        //         planBasicTypeName = item.title;
        //     }
        // });

        const finishData = {
            title            : data.title,
            areaPriceSale    : Utils.convertToDigit(data.salePrice),
            areaPriceBasic   : Utils.convertToDigit(data.price),
            image            : data.typeData.image,
            planoplan        : data.typeData.planoplan,
            favoritePlanID   : data.typeData.id,
            flatID           : data.flatID,
            planBasicTypeID  : data.typeData.layoutMainId,
            planFinalTypeName: data.typeData.title,
            planFinalImg     : data.typeData.image,
            planBasicTypeName,
            planTypeID,
            area,
            priceBasic,
            priceSale
        };

        this.planHead.innerText = planTypeID;
        this.result.insertAdjacentHTML('afterbegin', this.template(finishData));
        this._initFinishButton(finishData);
    }

    /* eslint-disable max-lines-per-function */
    _initFinishButton(finishData) {
        const saveButton = this.element.querySelector('.j-constructor__result-save');
        const saveFavorite = Array.from(this.element.querySelectorAll('.j-constructor__result-favorite'));
        const popupButtons = Array.from(this.element.querySelectorAll('.j-constructor__result-popup'));

        popupButtons.forEach((button) => {
            const flatNumber = document.querySelector('.j-flat-value[data-number]').getAttribute('data-number');
            const flatArea = document.querySelector('.j-flat-value[data-area]').getAttribute('data-area');
            const flatQueue = document.querySelector('.j-flat-value[data-queue]').getAttribute('data-queue');
            const flatFloor = document.querySelector('.j-flat-value[data-floor]').getAttribute('data-floor');
            const flatBuilding = document.querySelector('.j-flat-value[data-building]').getAttribute('data-building');
            const flatBasicPlanId = document.querySelector('.j-constructor-action__id[data-basic-plan-id]')
                .getAttribute('data-basic-plan-id');

            button.dataset.flatNumber = flatNumber;
            button.dataset.flatArea = flatArea;
            button.dataset.flatQueue = flatQueue;
            button.dataset.flatFloor = flatFloor;
            button.dataset.flatBuilding = flatBuilding;
            button.dataset.flatBasicImg = this.imageElement.src;
            button.dataset.flatBasicPlan = flatBasicPlanId;

            // Отправляем события Метрики и GA по клику
            button.addEventListener('click', () => {
                this._sendEvents(button.dataset.flatFinalPlanTitle);
            });
        });

        saveButton?.addEventListener('click', () => {
            this._saveChoose(finishData);

            this.popup.removePopup();
        });

        if (saveFavorite.length) {
            initFavorite(saveFavorite);

            saveFavorite.forEach((button) => {
                button.dataset.plan = finishData.favoritePlanID;

                button.addEventListener('click', () => {
                    this.popup.removePopup();

                    if (window.gtag) {
                        window.gtag('event', 'add_wishlist', {
                            // eslint-disable-next-line
                            send_to: 'G-LLQN03TWXX',
                            place  : 'constructor'
                        });
                    }
                });
            });
        }

        if (popupButtons.length) {
            const options = {
                ...{openButtons: popupButtons},
                parentPopup: this.popup
            };

            const facade = new PopupFacade(options);

            facade.init();
        }
    }
    /* eslint-enable max-lines-per-function */

    /* eslint-disable max-statements */
    /**
     * Сохраняем данные выбранного типа планировки
     * @param {object} data - объект с данными выбранной планировки
     */
    _saveChoose(data) {
        this.pagePlan.forEach((item) => {
            item.innerText = data.planTypeID ? data.planTypeID : item.innerText;
        });

        if (this.mainPrice) {
            if (this.oldPrice) {
                this.oldPrice.innerText = data.priceBasic ? data.priceBasic : this.oldPrice.innerText;
            }

            this.mainPrice.innerText = data.priceSale ? data.priceSale : this.mainPrice.innerText;
        }

        if (this.mortgagePayment) {
            data.priceSale ?
                observer.publish('popup-constructor:saveMortgage', Utils.convertToNumber(data.priceSale)) :
                observer.publish('popup-constructor:saveMortgage', Utils.convertToNumber(data.priceBasic));
        }


        if (this.areaPrice) {
            this.areaPrice.innerText = data.areaPriceSale ? data.areaPriceSale : data.areaPriceBasic;
        }

        if (this.mortgagePrice) {
            this.mortgagePrice.innerText = data.priceSale ? data.priceSale : data.priceBasic;
        }

        if (this.area.length) {
            this.area.forEach((item) => {
                item.innerText = data.area ? data.area : item.innerText;
            });
        }

        if (this.imagePopup) {
            this.imagePopup.dataset.media = data.image ? data.image : this.imagePopup.dataset.media;
        }

        if (this.imageElement) {
            this.imageElement.src = data.image ? data.image : this.imageElement.src;
        }
        // Изменяем планоплан если он был
        if (data.planoplan && this.planoplanWidget) {
            this._setPlanoplan(data.planoplan);
        }
        // Устанавливаем хеш в адресной строке
        this._setHash(data.favoritePlanID);
        // Устанавливаем тип выбранной планировки в кнопку избранного на странице квартиры
        this.favorite.dataset.plan = data.favoritePlanID;
    }
    /* eslint-enable max-statements */

    _setPlanoplan(uid) {
        this.planoplanWidget.dataset.uid = uid;

        observer.publish('planoplan:reinit');
    }

    /**
     * Устанавливаем выбранную планировку в адресную строку, на случай если пользователь добавит планировку в избранное браузера средствами браузера
     * @param {string} favoritePlanID - номер планировки
     */
    _setHash(favoritePlanID) {
        const query = new URLSearchParams();
        const hash = window.location.hash;
        const searchParams = new URLSearchParams(window.location.search);

        query.append('type', favoritePlanID);

        // Если были данные ипотеки в гет параметрах, возвращаем их в адресную строку
        searchParams.forEach((item, key) => {
            if (key !== 'type') {
                query.append(key, searchParams.get(key));
            }
        });

        window.history.pushState(null, null, `?${query.toString()}${hash}`);
    }

    // Сравнение массивов
    _compareArray(arr1, arr2) {
        return arr2.every((arr2Item) => {
            return arr1.includes(arr2Item);
        });
    }

    // Устанавливаем текст подсказку
    _setStepText(text) {
        this.stepText.innerText = text;
    }

    /**
     * Отправляем события Метрики и GA по клику
     * @param {string} plan - итоговая планировка
     */
    _sendEvents(plan) {
        if (window.gtag) {
            try {
                window.gtag('event', 'constructor_save', {
                    // eslint-disable-next-line
                    send_to : 'G-LLQN03TWXX',
                    // eslint-disable-next-line
                    tip_plan: plan
                });
                // eslint-disable-next-line
                console.log('constructor_save', plan);
            } catch (error) {
                console.error(error);
            }
        }

        if (window.ym) {
            window.ym(91302277, 'reachGoal', 'Button_save_changes');
        }
    }
}

export default FlatConstructor;
